export default {"src":"/_next/static/media/Learning_Zone.9ee73560.svg","height":30,"width":26};